<template>
  <div class="card p-3">
    <form-field
      v-for="(field, key) in fields"
      :key="key"
      :type="field.type"
      :input-type="field.inputType"
      :label="field.label"
      :name="field.name"
      :helpText="field.helpText"
      :placeholder="field.placeholder"
      :allowMultiple="field.allowMultiple"
      :choices="field.choices"
      :answers="field.answers"
      :inline="field.inline"
      :showResult="field.showResult"
      v-model="model[field.id]"
    >
    </form-field>
    <base-button
      v-if="showSubmit"
      @click="submit">
      Submit
    </base-button>
    <div v-if="!fields">
      <h5>Ожидается правильная схема</h5>
    </div>
  </div>

</template>

<script>
  import FormField from "./FormField";

  export default {
    name: "FormPreview",
    components: {FormField},
    computed: {
      success() {
        return this.model.answers === this.answers
      },
      fields() {
        return this.schema.fields || []
      },
    },
    props: {
      schema: {
        type: Object,
        required: true
      },
      showSubmit: {
        type: Boolean,
        default: false
      }
    },
    created() {

    },
    data() {
      return {
        model: {}
      }
    },
    methods: {
      emitter(val) {
        if (val) {
          this.$emit("input", val)
        }
      },
      refreshModelKeys() {
        this.model = {};
        this.fields.forEach((value => this.model[value.id]));
      },
      submit() {
        this.$emit("submit", this.model)
      }
    },
    watch: {
      'model': function (val) {
        this.emitter(val)
      },
      'fields': function () {
        this.refreshModelKeys()
      }
    }
  }
</script>

<style scoped>

</style>
